
import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AppointmentService, ClassBookingService, ClassService, ClientService, TimeconversionService } from '@fitness-force/api';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { AppointmentStatus, ClientBookingStatus, ScheduleType } from '@fitness-force/enum';
import { AppErrors } from '@fitness-force/errors';
import {
  Appointment,
  CancelAppointmentRequest,
  Class,
  ClientBookings,
  ClientSessionInventory,
  CompClassRequest,
  ListAppointmentByClientRequest,
  ListClassByClientRequest,
  MarkClientCheckedinRequest,
  MarkClientNoshowRequest,
  RemoveClientFromClassRequest,
  TENANTSINTERFACE,
} from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  TENANTS_INFO,
} from 'apps/ff-frontend/src/app/state/app.state';
import { ToastMessageService } from '@fitness-force/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { MessageModule } from 'primeng/message';
import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';

import { BehaviorSubject, forkJoin, map, Observable } from 'rxjs';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { DataGridComponent, NoBookingsComponent } from '@fitness-force/grid';
import { BookingActionsComponent } from '../../data-grid/utility/booking-actions/booking-actions.component';
import { BookingStatusComponent } from '../../data-grid/utility/booking-status/booking-status.component';
import { BookingTypeComponent } from '../../data-grid/utility/booking-type/booking-type.component';
import { DateFormatedComponent} from '@fitness-force/grid-utility'
import { BookAppointmentComponent } from '../../schedule/appointment/book-appointment/book-appointment.component';
import { ViewAppointmentComponent } from '../../schedule/appointment/view-appointment/view-appointment.component';
import { StaffInfoComponent } from '../../staff/staff-info/staff-info.component';
import { MessageService } from 'primeng/api';
// import { ViewClassComponent } from '../../schedule/class/view-class/view-class.component';
@Component({
  selector: 'client-booking-tab',
  templateUrl: './client-booking-tab.component.html',
  styleUrls: ['./client-booking-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService, MessageService],
  standalone: true,
  imports: [
    CommonModule,
    DividerModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    SelectModule,
    DialogModule,
    AvatarModule,
    CheckboxModule,
    TagModule,
    DatePickerModule,
    TableModule,
    SkeletonModule,
    PopoverModule,
    StyleClassModule,
    MessageModule,
    DataGridComponent,
    DateTimeFormatPipe,
    ViewAppointmentComponent,
    BookAppointmentComponent,
    TranslateModule
]
})
export class ClientBookingTabComponent implements OnInit {
  @Input('clientId') clientId: number = 0;
  showSkeleton: boolean = true;
  getAccessTenantList$: Observable<any>;
  tags: string[] | undefined;
  bookingData: any[];
  tenantId = 0;
  appointmentList$ = new BehaviorSubject<Appointment[]>([]);
  classList$ = new BehaviorSubject<Class[]>([]);
  pastAppointmentList$ = new BehaviorSubject<Appointment[]>([]);
  pastClassList$ = new BehaviorSubject<Class[]>([]);
  futureClassAppointmentList = new BehaviorSubject<ClientBookings[]>([]);
  pastClassAppointmentList = new BehaviorSubject<ClientBookings[]>([]);
  columns: any = new BehaviorSubject([]);
  loading = new BehaviorSubject<boolean>(true);
  emptyStateComponent$ = new BehaviorSubject<any>(NoBookingsComponent);
  Subscriptions$ = new BehaviorSubject<ClientSessionInventory[]>([]);
  showBookAppointmentPopup: boolean = false;
  futureLoading: boolean = false;
  pastLoading: boolean = false;
  selectable = new BehaviorSubject<boolean>(false);
  column!: any;
  weekDays = [{ key: 'Sunday', value: -1 }, { key: 'Monday', value: -2 },
  { key: 'Tuesday', value: -3 }, { key: 'Wednesday', value: -4 },
  { key: 'Thursday', value: -5 }, { key: 'Friday', value: -6 },
  { key: 'Saturday', value: -7 }];
  compSession: boolean = false;
  days: Array<string> = CONSTANTS_DATA.DAYS;
  viewAppointmentSidebar: Observable<boolean> | any = false;
  viewClassPopup: Observable<boolean> | any = false;
  appointmentObject: Appointment | undefined;
  classObject: Class | undefined;
  deleteAppointmentForm: UntypedFormGroup = new UntypedFormGroup({});
  complimentoryForm: UntypedFormGroup = new UntypedFormGroup({});
  cancelAppointment: boolean = false;
  future_startDate: Date;
  future_endDate: Date;
  past_startDate: Date;
  past_endDate: Date;
  loadingfutureStartDate:Date;
  loadingfutureEndDate:Date;
  loadingPastStartDate:Date;
  loadingPastEndDate:Date;
  pastCurrentDate:Date;
  isComplimentoryLoading:boolean=false;
  isPastBookingClicked:boolean=false;
  

  constructor(
    private appointmentService: AppointmentService,
    private classService: ClassService,
    private clientService: ClientService,
    private store: Store,
    private translate: TranslateService,
    private classBookingService: ClassBookingService,
    private toastMessageService: ToastMessageService,
    private timeService: TimeconversionService,
    private fb: UntypedFormBuilder,
    public datepipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) {
  }


  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });
    this.deleteAppointmentForm = this.fb.group({
      cancellation_reason: ['', [Validators.required]],
      appointmentId: []
    });

    this.complimentoryForm = this.fb.group({
      comments: ['', [Validators.required]],
      booking_id: []
    });
    this.future_startDate = new Date(new Date());
    this.future_endDate = new Date(new Date(this.future_startDate).setMonth(new Date(this.future_startDate).getMonth() + 1));
    let dte = new Date();
    this.past_startDate = new Date(dte.setDate(dte.getDate() - 1));
    this.past_endDate = new Date(new Date(this.future_startDate).setMonth(new Date(this.future_startDate).getMonth() - 1));

    this.loadingfutureStartDate = this.future_startDate;
    this.loadingfutureEndDate = this.future_endDate;
    this.loadingPastStartDate = this.past_endDate;
    this.loadingPastEndDate = this.past_startDate;
    this.pastCurrentDate = this.past_startDate;

    this.GetClassAppointments(this.future_startDate, this.future_endDate);
    this.GetPastClassAppointments(this.past_endDate, this.past_startDate);
    this.getAllSubscriptions();
  }

  getAllSubscriptions() {
    this.clientService.getClientSessionInventory(this.tenantId, this.clientId).subscribe({
      next: (response: any) => {
        this.loading.next(false);
        if (response && response.items) {
          let res: ClientSessionInventory[] = response.items as ClientSessionInventory[]
          this.Subscriptions$.next(res);
        } else {
          this.Subscriptions$.next([]);
        }
        this.showSkeleton = false;
      },
      error: (error) => {

      },
    });
  }

  GetPastClassAppointments(startDate: Date, endDate: Date) {
    const getAppointmentRequest: ListAppointmentByClientRequest = {
      tenant_id: this.tenantId,
      client_id: this.clientId,
      start_datetime:  this.datepipe.transform(startDate.toISOString(), 'yyyy-MM-dd')!,
      end_datetime:  this.datepipe.transform(endDate.toISOString(), 'yyyy-MM-dd')!
    };

    const getClassesRequest: ListClassByClientRequest = {
      tenant_id: this.tenantId,
      client_id: this.clientId,
      start_date: this.datepipe.transform(startDate.toISOString(), 'yyyy-MM-dd')!,
      end_date: this.datepipe.transform(endDate.toISOString(), 'yyyy-MM-dd')!,
    };

    forkJoin({
      appointments: this.appointmentService.GetAppointmentsByClient(getAppointmentRequest),
      classes: this.classService.GetClassesByClient(getClassesRequest),
    }).pipe(
      map((response) => {
        const appointments: Appointment[] = response.appointments.items ? response.appointments.items : [];
        const classes: Class[] = response.classes.items ? response.classes.items : [];
        appointments.forEach((appt) => {
          appt.type = ScheduleType.Apppintment;
          appt.start_datetime = this.timeService.ConvertUTCToLocalDateTime(appt.start_datetime);
          appt.end_datetime = this.timeService.ConvertUTCToLocalDateTime(appt.end_datetime);
        });
        classes.forEach((cls) => {
          cls.type = ScheduleType.Class;
          cls.start_datetime = this.timeService.ConvertUTCToLocalDateTime(cls.start_datetime);
          cls.end_datetime = this.timeService.ConvertUTCToLocalDateTime(cls.end_datetime);
        });
        this.pastAppointmentList$.next([...this.pastAppointmentList$.getValue(), ...appointments.filter(o => o.status.toLowerCase() != 'cancelled')]);
        this.pastClassList$.next([...this.pastClassList$.getValue(), ...classes.filter(o => o.status.toLowerCase() != 'cancelled')]);
        return this.CreateEvents(this.getPastAppointments, this.getPastClasses);
      })
    )
      .subscribe({
        next: (data: any) => {
          var bookingdata = data.sort(function (a: { EndDate: number; }, b: { StartDate: number; }) {
            return b.StartDate - a.EndDate;
          });
          this.pastClassAppointmentList.next(bookingdata);
          this.columnTranslate();
          this.loading.next(false);
          this.showSkeleton = false;
          this.pastLoading = false;
        },
        error: (error: any) => {
          this.loading.next(false);
          this.appointmentList$.next([]);
          this.classList$.next([]);
          this.pastClassAppointmentList.next([]);
          this.showSkeleton = false;
          this.pastLoading = false;
        },
      });
  }

  GetClassAppointments(startDate: Date, endDate: Date) {
    const getAppointmentRequest: ListAppointmentByClientRequest = {
      tenant_id: this.tenantId,
      client_id: this.clientId,
      start_datetime: this.datepipe.transform(startDate.toISOString(), 'yyyy-MM-dd')!,
      end_datetime: this.datepipe.transform(endDate.toISOString(), 'yyyy-MM-dd')!,
    };

    const getClassesRequest: ListClassByClientRequest = {
      tenant_id: this.tenantId,
      client_id: this.clientId,
      start_date: this.datepipe.transform(startDate.toISOString(), 'yyyy-MM-dd')!,
      end_date: this.datepipe.transform(endDate.toISOString(), 'yyyy-MM-dd')!,
    };

    forkJoin({
      appointments: this.appointmentService.GetAppointmentsByClient(getAppointmentRequest),
      classes: this.classService.GetClassesByClient(getClassesRequest),
    }).pipe(
      map((response) => {
        const appointments: Appointment[] = response.appointments.items ? response.appointments.items : [];
        const classes: Class[] = response.classes.items ? response.classes.items : [];
        appointments.forEach((appt) => {
          appt.type = ScheduleType.Apppintment;
          appt.start_datetime = this.timeService.ConvertUTCToLocalDateTime(appt.start_datetime).toString();
          appt.end_datetime = this.timeService.ConvertUTCToLocalDateTime(appt.end_datetime).toString();
        });
        classes.forEach((cls) => {
          cls.type = ScheduleType.Class;
          cls.start_datetime = this.timeService.ConvertUTCToLocalDateTime(cls.start_datetime).toString();
          cls.end_datetime = this.timeService.ConvertUTCToLocalDateTime(cls.end_datetime).toString();
        });
        this.appointmentList$.next([...this.appointmentList$.getValue(), ...appointments.filter(o => o.status.toLowerCase() != 'cancelled')]);
        this.classList$.next([...this.classList$.getValue(), ...classes.filter(o => o.status.toLowerCase() != 'cancelled')]);
        return this.CreateEvents(this.getAppointments, this.getClasses);
      })
    )
      .subscribe({
        next: (data: any) => {
          var bookingdata = data.sort(function (a: { StartDate: number; }, b: { EndDate: number; }) {
            return a.StartDate - b.EndDate;
          });
          this.futureClassAppointmentList.next(bookingdata);
          this.columnTranslate();
          this.loading.next(false);
          this.showSkeleton = false;
          this.futureLoading = false;
        },
        error: (error: any) => {
          this.loading.next(false);
          this.appointmentList$.next([]);
          this.classList$.next([]);
          this.futureClassAppointmentList.next([]);
          this.showSkeleton = false;
          this.futureLoading = false;
        },
      });
      this.cdr.detectChanges();
  }



  CreateEvents(appointments: Appointment[], classes: Class[]) {
    const bookings: ClientBookings[] = [];
    appointments.forEach((appt) => {
      let booking: ClientBookings = {} as ClientBookings;
      booking.AppointmentId = appt.id,
        booking.Type = ScheduleType.Apppintment,
        booking.TypeName = appt.type_name_primary_language,
        booking.TypeColor = appt.type_color,
        booking.Status = appt.status,
        booking.CoachId = appt.coach_id,
        booking.CoachName = appt.coach_name,
        booking.CoachDescription = appt.coach_description,
        booking.CoachImageUrl = appt.coach_image_url,
        booking.StartDate = appt.start_datetime;
        booking.EndDate = appt.end_datetime;
        bookings.push(booking);
    });
    classes.forEach((cls) => {
      let booking: ClientBookings = {} as ClientBookings;
      booking.ClassId = cls.id,
        booking.Type = ScheduleType.Class,
        booking.TypeName = cls.type_name_primary_language,
        booking.TypeColor = cls.type_color,
        booking.BookingStatus = cls.booking_status,
        booking.CoachId = cls.coach_id,
        booking.CoachName = cls.coach_name,
        booking.CoachImageUrl = cls.coach_image_url,
        booking.StartDate = cls.start_datetime;
        booking.EndDate = cls.end_datetime;
        booking.BookingId = cls.booking_id;
      bookings.push(booking);
    });
    return bookings;
  }


  columnTranslate() {
    this.translate
      .get([
        'CLIENT_BOOKING.DATETIME',
        'CLIENT_BOOKING.BOOKING_TYPE',
        'CLIENT_BOOKING.TRAINER',
        'CLIENT_BOOKING.STATUS'
      ])
      .subscribe((translations) => {
        this.setColumnTranslate(translations);
      });
  }

  setColumnTranslate(translations: any) {
    this.column = {
      DateTime: translations['CLIENT_BOOKING.DATETIME'],
      BookingType: translations['CLIENT_BOOKING.BOOKING_TYPE'],
      Trainer: translations['CLIENT_BOOKING.TRAINER'],
      Status: translations['CLIENT_BOOKING.STATUS'],
    };
    this.columns.next([
      {
        title: this.column.DateTime,
        classes: 'py-3 white-space-nowrap align-items-center',
        dataProperty: 'StartDate',
        type: 'component',
        data: {
          name: DateFormatedComponent, additionData: true, aData: { KeyName: 'StartDate', format: 'datetime',applytimezone:false }
        },
      },
      {
        title: this.column.BookingType,
        classes: 'py-3 white-space-nowrap',
        dataProperty: 'Type',
        type: 'component',
        data: { name: BookingTypeComponent },
      },
      {
        title: this.column.Trainer,
        classes: 'py-3 white-space-nowrap',
        dataProperty: 'CoachId',
        type: 'component',
        data: { name: StaffInfoComponent },
      },
      {
        title: this.column.Status,
        classes: 'py-3 white-space-nowrap',
        sortable: false,
        filterable: true,
        dataProperty: 'Status',
        type: 'component',
        data: { name: BookingStatusComponent },
      },
      {
        title: '',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'actions',
        type: 'component',
        data: {
          name: BookingActionsComponent,
          additionData: true,
          aData: ['compsession', 'remove', 'checkin', 'noshow', 'reschedule', 'cancel', 'attended'],
        },
      },
    ]);
  }


  onActionEvent(event: any) {
    switch (event.action.toLowerCase()) {
      case 'compsession':
        {
          this.complimentoryForm.controls.booking_id.setValue(event.columnData.BookingId);
          this.compSession = true;
        }

        break;
      case 'remove':
        {
          this.RemoveClientFromClass(event.columnData.ClassId);
          break;
        }
      case 'checkin':
        {
          this.MarkClientCheckedIn(event.columnData.ClassId);
        }
        break;
      case 'noshow':
        {
          this.MarkClientNoshow(event.columnData);
        }
        break;
        break;
      case 'reschedule':
        {
          if (this.getAppointments.find(o => o.id == event.columnData.AppointmentId)) {
            this.appointmentObject = this.getAppointments.find(o => o.id == event.columnData.AppointmentId);
          }
          else if (this.getPastAppointments.find(o => o.id == event.columnData.AppointmentId)) {
            this.appointmentObject = this.getPastAppointments.find(o => o.id == event.columnData.AppointmentId);
          }
          this.viewAppointmentSidebar = true;
          break;
        }
      case 'cancel':
        {
          if (this.getAppointments.find(o => o.id == event.columnData.AppointmentId)) {
            this.appointmentObject = this.getAppointments.find(o => o.id == event.columnData.AppointmentId);
          }
          else if (this.getPastAppointments.find(o => o.id == event.columnData.AppointmentId)) {
            this.appointmentObject = this.getPastAppointments.find(o => o.id == event.columnData.AppointmentId);
          }
          this.deleteAppointmentForm.controls.appointmentId.setValue(event.columnData.AppointmentId);
          this.cancelAppointment = true;
          break;
        }
      case 'attended':
        {
          this.MarkClientAsAttended(event.columnData.AppointmentId);
        }
        break;
    }
  }

  CloseViewAppointment(event: any) {
    this.viewAppointmentSidebar = false;
  }

  handleEvent(event: any) {
    if (event.appointment) {
      if (this.getAppointments.find(o => o.id == event.appointment.id)) {
        this.appointmentList$.value.map((appt) => {
          if (appt.id == event.appointment.id) {
            appt = event.appointment;
          }
        });
        const eventss = this.CreateEvents(this.appointmentList$.value, this.getClasses);
        const sortedAsc = eventss.sort(
          (objA, objB) => new Date(objA.StartDate).getTime() - new Date(objB.StartDate).getTime(),
        );
        this.futureClassAppointmentList.next(sortedAsc);
      }
      else if (this.getPastAppointments.find(o => o.id == event.appointment.id)) {
        this.pastAppointmentList$.value.map((appt) => {
          if (appt.id == event.appointment.id) {
            appt = event.appointment;
          }
        });
        const eventss = this.CreateEvents(this.pastAppointmentList$.value, this.getPastClasses)
        const sortedDesc = eventss.sort(
          (objA, objB) => new Date(objB.StartDate).getTime() - new Date(objA.StartDate).getTime(),
        );
        this.pastClassAppointmentList.next(sortedDesc);
      }
    }
  }

  RemoveClientFromClass(classId: number) {
    let removeClientFromClass: RemoveClientFromClassRequest = {} as RemoveClientFromClassRequest;
    let clientids: number[] = [];
    clientids.push(this.clientId);
    removeClientFromClass.client_ids = clientids;
    this.classBookingService.RemoveClientsToClass(this.tenantId, classId, removeClientFromClass)
      .subscribe({
        next: (data: any) => {
          this.translate.get('SCHEDULE.VIEWCLASS.MSG.REMOVE_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          if (this.getFuturebooking.find(o => o.ClassId == classId)) {
            this.getFuturebooking.forEach(o => {
              if (o.ClassId == classId) o.BookingStatus = ClientBookingStatus.Cancelled
            });
            this.futureClassAppointmentList.next(this.getFuturebooking);
            this.columnTranslate();
          }

        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  MarkClientCheckedIn(classId: number) {
    let clientCheckedInRequest: MarkClientCheckedinRequest = {} as MarkClientCheckedinRequest;
    let clientids: number[] = [];
    clientids.push(this.clientId);
    clientCheckedInRequest.client_ids = clientids;
    this.classBookingService.MarkCheckedIn(this.tenantId, classId, clientCheckedInRequest)
      .subscribe({
        next: (data: any) => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.MARK_CHECKEDIN_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          if (this.getFuturebooking.find(o => o.ClassId == classId)) {
            this.getFuturebooking.forEach(o => {
              if (o.ClassId == classId) o.BookingStatus = ClientBookingStatus.Attended
            });
            this.futureClassAppointmentList.next(this.getFuturebooking);
            this.columnTranslate();
          }
          else if (this.getPastbooking.find(o => o.ClassId == classId)) {
            this.getPastbooking.forEach(o => {
              if (o.ClassId == classId) o.BookingStatus = ClientBookingStatus.Attended
            });
            this.pastClassAppointmentList.next(this.getPastbooking);
            this.columnTranslate();
          }
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  MarkClientNoshow(data: ClientBookings) {
    if (data.Type == ScheduleType.Class) {
      let clientNoShowRequest: MarkClientNoshowRequest = {} as MarkClientNoshowRequest;
      let clientids: number[] = [];
      clientids.push(data.ClassId);
      clientNoShowRequest.client_ids = clientids;
      this.classBookingService.MarkNoShow(this.tenantId, this.clientId, clientNoShowRequest)
        .subscribe({
          next: (data: any) => {
            this.translate
              .get('SCHEDULE.VIEWCLASS.MSG.MARK_NOSHOW_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            if (this.getFuturebooking.find(o => o.ClassId == data.ClassId)) {
              this.getFuturebooking.forEach(o => {
                if (o.ClassId == data.ClassId) o.BookingStatus = ClientBookingStatus.NoShow
              });
              this.futureClassAppointmentList.next(this.getFuturebooking);
              this.columnTranslate();
            }
            else if (this.getPastbooking.find(o => o.ClassId == data.ClassId)) {
              this.getPastbooking.forEach(o => {
                if (o.ClassId == data.ClassId) o.BookingStatus = ClientBookingStatus.NoShow
              });
              this.pastClassAppointmentList.next(this.getPastbooking);
              this.columnTranslate();
            }
          },
          error: (error: AppErrors) => {
            this.ShowToastErrors(error);
          },
        });
    }
    else {
      this.appointmentService.MarkClientNoShow(this.tenantId, data.AppointmentId)
        .subscribe({
          next: (data: any) => {
            this.translate.get('SCHEDULE.MSG.MARK_NOSHOW_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            if (this.getFuturebooking.find(o => o.ClassId == data.AppointmentId)) {
              this.getFuturebooking.forEach(o => {
                if (o.AppointmentId == data.AppointmentId) o.Status = AppointmentStatus.NoShow
              });
              this.futureClassAppointmentList.next(this.getFuturebooking);
              this.columnTranslate();
            }
            else if (this.getPastbooking.find(o => o.ClassId == data.AppointmentId)) {
              this.getPastbooking.forEach(o => {
                if (o.AppointmentId == data.AppointmentId) o.Status = AppointmentStatus.NoShow
              });
              this.pastClassAppointmentList.next(this.getPastbooking);
              this.columnTranslate();
            }
          },
          error: (error: AppErrors) => {
            this.ShowToastErrors(error);
          },
        });
    }
  }

  CancelAppointment(form: any) {
    let cancelRequest: CancelAppointmentRequest = {} as CancelAppointmentRequest;
    cancelRequest.cancellation_reason = form.value.cancellation_reason;
    this.appointmentService.CancelAppointment(this.tenantId, form!.value.appointmentId, cancelRequest)
      .subscribe({
        next: async (data: any) => {
          this.translate.get('SCHEDULE.MSG.CANCEL_APPT')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.cancelAppointment = false;
          if (this.getFuturebooking.find(o => o.AppointmentId == form!.value.appointmentId)) {
            this.getFuturebooking.forEach(o => {
              if (o.AppointmentId == form!.value.appointmentId) o.Status = AppointmentStatus.Cancelled
            });
            this.futureClassAppointmentList.next(this.getFuturebooking);
            this.columnTranslate();
          }
          else if (this.getPastbooking.find(o => o.AppointmentId == form!.value.appointmentId)) {
            this.getPastbooking.forEach(o => {
              if (o.AppointmentId == form!.value.appointmentId) o.Status = AppointmentStatus.Cancelled
            });
            this.futureClassAppointmentList.next(this.getPastbooking);
            this.columnTranslate();
          }
          this.resetForm();
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  MarkClientAsAttended(appointmentId: number) {
    this.appointmentService.MarkClientCheckIn(this.tenantId, appointmentId)
      .subscribe({
        next: (data: any) => {
          this.translate.get('SCHEDULE.MSG.MARK_CHECKEDIN_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          if (this.getFuturebooking.find(o => o.AppointmentId == appointmentId)) {
            this.getFuturebooking.forEach(o => {
              if (o.AppointmentId == appointmentId) o.Status = AppointmentStatus.Attended
            });
            this.futureClassAppointmentList.next(this.getFuturebooking);
            this.columnTranslate();
          }
          else if (this.getPastbooking.find(o => o.AppointmentId == appointmentId)) {
            this.getPastbooking.forEach(o => {
              if (o.AppointmentId == appointmentId) o.Status = AppointmentStatus.Attended
            });
            this.futureClassAppointmentList.next(this.getPastbooking);
            this.columnTranslate();
          }
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  ComplimentoryClass(form: any) {
    this.isComplimentoryLoading=true;
    let compClassRequest: CompClassRequest = {} as CompClassRequest;
    compClassRequest.comment = form.value.comments;
    this.classBookingService.MarkComplimentoryClass(this.tenantId, this.clientId, form!.value.booking_id, compClassRequest)
      .subscribe({
        next: async (data: any) => {
          this.translate.get('CLIENT_BOOKING.COMP_COMPLETED')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.cancelAppointment = true;
          this.resetForm();
          this.isComplimentoryLoading=false;
          this.cdr.detectChanges();
        },
        error: (error: AppErrors) => {
          this.isComplimentoryLoading=false;
          this.ShowToastErrors(error);
          this.cdr.detectChanges();
        },
      });
  }

  resetForm() {
    this.deleteAppointmentForm.reset();
    this.cancelAppointment = false;
    this.compSession = false;
  }

  ShowToastErrors(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e);
      });
    } else {
      this.toastMessageService.showErrorMessage(error);
    }
  }

  CloseBookAppointment(event: any) {
    this.showBookAppointmentPopup = event;
  }

  reloadEvents(event: any) {
    this.pastAppointmentList$.next([]);
    this.pastClassList$.next([]);
    this.appointmentList$.next([]);
    this.classList$.next([]);
    this.futureClassAppointmentList.next([]);
    this.pastClassAppointmentList.next([]);
    this.GetClassAppointments(this.future_startDate, this.future_endDate);
    this.GetPastClassAppointments(this.past_startDate, this.past_endDate);
  }

  getFutureData() {
    this.futureLoading = true;
    this.future_startDate = this.future_endDate;
    this.future_endDate = new Date(new Date(this.future_startDate).setMonth(new Date(this.future_startDate).getMonth() + 1));
    this.loadingfutureEndDate = this.future_endDate;
    this.cdr.detectChanges();
    this.GetClassAppointments(this.future_startDate, this.future_endDate);
  }

  getPastData() {
    this.pastLoading = true;
    this.isPastBookingClicked = true;
    this.past_startDate = this.past_endDate;
    this.past_endDate = new Date(new Date(this.past_startDate).setMonth(new Date(this.past_startDate).getMonth() - 1));
    this.loadingPastEndDate =  this.past_endDate;
    this.cdr.detectChanges();
    this.GetPastClassAppointments(this.past_endDate, this.past_startDate);
  }

  handleTableEvent(e: any) {
    if (e.selection) {
      if (this.getAppointments.find(o => o.id == e.data.data.AppointmentId)) {
        this.appointmentObject = this.getAppointments.find(o => o.id == e.data.data.AppointmentId);
      }
      else if (this.getPastAppointments.find(o => o.id == e.data.data.AppointmentId)) {
        this.appointmentObject = this.getPastAppointments.find(o => o.id ==e.data.data.AppointmentId);
      }
      this.viewAppointmentSidebar = true;
    }
    else {
     
    }
  }

  getTotakBookings() {
    return (this.futureClassAppointmentList.value.length + this.pastClassAppointmentList.value.length)
  }

  getStatus(startDate: any, endDate: any): { status: string, severity: string } {
    let res: { status: string, severity: string } = { status: '', severity: '' };
    
    // Strip time components from current date
    const currentDate = new Date();
    const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    
    // Convert and strip time from start date
    const convertedStartDate = this.timeService.ConvertUTCToLocalDateTime(startDate);
    const startDateOnly = new Date(convertedStartDate.getFullYear(), convertedStartDate.getMonth(), convertedStartDate.getDate());
    
    // Convert and strip time from end date
    const convertedEndDate = this.timeService.ConvertUTCToLocalDateTime(endDate);
    const endDateOnly = new Date(convertedEndDate.getFullYear(), convertedEndDate.getMonth(), convertedEndDate.getDate());
  
    if (endDateOnly < today) {
      res.status = 'expired';
      res.severity = 'danger';
    } else if (startDateOnly <= today && endDateOnly >= today) {
      res.status = 'active';
      res.severity = 'success';
    } else {
      res.status = 'future';
      res.severity = 'info';
    }
    
    return res;
  }



  get getFuturebooking() {
    return this.futureClassAppointmentList.getValue();
  }

  get getPastbooking() {
    return this.pastClassAppointmentList.getValue();
  }

  get getAppointments() {
    return this.appointmentList$.getValue();
  }

  get getClasses() {
    return this.classList$.getValue();
  }

  get getPastAppointments() {
    return this.pastAppointmentList$.getValue();
  }

  get getPastClasses() {
    return this.pastClassList$.getValue();
  }

}
